module.exports = __webpack_public_path__ + "img/hourglass-svgrepo-com.f8eb7b39.svg";